let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b7yMb")).then(() => parcelRequire('5Wu0a'));